import { Plus, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "@/section/router";
import { TemplateListSection } from "../TemplateList";

export function DestinationPacketsTemplatesPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wide">
            Destination Packets
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => navigate(RoutePath.DestinationPacketsSendEnvelope)}
          >
            <Send className="mr-2 h-4 w-4" />
            Send Envelope
          </Button>
          <Button onClick={() => navigate(RoutePath.DestinationPacketsTemplatesCreate)}>
            <Plus className="mr-2 h-4 w-4" />
            Create Template
          </Button>
        </div>
      </div>

      <TemplateListSection />
    </div>
  );
}

